<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              终端名称：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.storeName"
              placeholder="请输入终端名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.benxiangStoreNo"
              placeholder="请输入本香门店码"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.phone"
              placeholder="请输入联系电话"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="selectItemFun()"
            >
              选择零售户
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :multiple-selection.sync="multipleSelection"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @selectItem="selectItemFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { loadStoreListDataApi } from '@/api/store'
export default {
  name: 'StoreList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    cityId: {
      type: String,
      default: ''
    },
    certificateNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'store_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择该零售户',
            method: 'selectItem'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            storeName: '',
            certificateNo: '',
            benxiangStoreNo: '',
            phone: '',
            billType: 1,
            cityId: '',
            provinceId: ''
          }
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.tableList.tableQuery.search.storeName = ''
        this.tableList.tableQuery.search.certificateNo = ''
        this.tableList.tableQuery.search.benxiangStoreNo = ''
        this.tableList.tableQuery.search.phone = ''
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'provinceName', label: '所属省区', filterColumn: 'province_name', width: 120 },
          { prop: 'cityName', label: '所属城市', filterColumn: 'city_name', width: 120 },
          { prop: 'countyName', label: '所属区县', filterColumn: 'county_name', width: 120 },
          { prop: 'ownerName', label: '店主', filterColumn: 'owner_name', width: 120 },
          { prop: 'phone', label: '联系电话', width: 120 },
          { prop: 'benxiangStoreNo', label: '本香门店码', filterColumn: 'benxiang_store_no', width: 140 },
          { prop: 'certificateNo', label: '专卖证号', filterColumn: 'certificate_no', width: 140 },
          { prop: 'storeName', label: '店名(专卖证)', filterColumn: 'store_name', width: 150 },
          { prop: 'address', label: '地址(专卖证)', width: 150 },
          { prop: 'realStoreName', label: '实际店名', filterColumn: 'real_store_name', width: 150 },
          { prop: 'realAddress', label: '实际地址', filterColumn: 'real_address', width: 150 },
          { prop: 'remark', label: '备注', width: 200 }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.search.provinceId = ''
        this.tableList.tableQuery.search.cityId = this.cityId
        this.tableList.tableQuery.search.certificateNo = this.certificateNo
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadStoreListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择终端
    selectItemFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择零售户',
          type: 'warning'
        })
        return false
      } else if (this.multipleSelection.length > 1) {
        this.$message({
          message: '只能选择一个零售户',
          type: 'warning'
        })
        return false
      } else {
        this.$emit('selectedStoreFun', this.multipleSelection[0])
        this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
